import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import AppSetup from "../core/AppSetup";
import { IUmkreis } from "../interfaces/Tanker";

const apiUrl = AppSetup.getUserApiUrl();
axios.defaults.baseURL = apiUrl;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.post['Content-Type'] = 'application/json';

const setToken = () => {
    const authToken = localStorage.getItem("AUTHTOKEN");
    axios.defaults.headers.common.AuthToken =  authToken ? authToken : "";
}

export const getStations = createAsyncThunk(
    "get/stations",
    async (u: IUmkreis, thunkAPI) => {
        setToken();
        // tank/stations?lat=52.521&lng=13.438&rad=3.0&sort=price&type=diesel
        const url = "?lat=" + u.lat + "&lng=" + u.lng + "&rad=" + u.rad + "&sort=" + u.sort + "&type=" + u.type; 
        try {
            return await axios.get("tank/stations" + url);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});

export const getDetails = createAsyncThunk(
    "get/details",
    async (id: string, thunkAPI) => {
        setToken();
        try {
            return await axios.get("tank/details?id=" + id);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});

export const setFavorit = createAsyncThunk(
    "put/setFavorit",
    async (p: {id: string, isFavorit: boolean, userId: string}, thunkAPI) => {
        setToken();
        try {
            return await axios.put("tank/favorit?id=" + p.id, {user_id: p.userId, is_favorit: p.isFavorit});
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});

export const getFavorites = createAsyncThunk(
    "get/favorites",
    async (user_id: string, thunkAPI) => {
        setToken();
        try {
            return await axios.get("tank/favorites?user_id" + user_id);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});


